var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key-value-wrapper"},_vm._l((_vm.value),function(item){return _c('div',{key:item.label,staticClass:"key-value-item",class:{ between: _vm.between },style:({ flex: `0 0 ${100 / _vm.col}%` })},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(item.label)+"：")]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }